/**
 * The main api service
 */
import http from "@util/http";
import { crm } from "../req";

/**
 * 获取客户总表
 */
export async function queryCustomList(params) {
  return http.get(crm.GET_CUSTOM_LIST, params);
}

/**
 * 保存客户信息
 */
export async function querySaveCustom(params) {
  return http.post(crm.SAVE_CUSTOM, params);
}

/**
 * 客户明细
 */
export async function queryCustomInfo(uuid) {
  return http.get(crm.GET_CUSTOM_INFO, { uuid });
}

/**
 * 删除客户信息
 */
export async function queryDeleteCustom(uuid) {
  return http.get(crm.DEL_CUSTOM, { uuid });
}

/**
 * 获取客户的公司列表
 */
export async function queryCustomCompany(params) {
  return http.get(crm.GET_CUSTOM_COMPANY, params);
}

/**
 * 组织设置明细
 */
export async function querySaveCustomCompany(parms) {
  return http.post(crm.SAVE_CUSTOM_COMPANY, parms);
}

/**
 * 获取公司的客户列表
 */
export async function queryCompanyCustomList(params) {
  return http.get(crm.GET_COMPANY_CUSTOM, params);
}

/**
 * 添加客户公司
 */
export async function querySaveCompanyCustom(params) {
  return http.post(crm.SAVE_COMPANY_CUSTOM, params);
}

/**
 * 获取客户的资金列表
 */
export async function queryCustomBillList(params) {
  return http.get(crm.GET_CUSTOM_BILL_LIST, params);
}

/**
 * 保存客户资金
 */
export async function querySaveCustomBill(params) {
  return http.post(crm.SAVE_CUSTOM_BILL, params);
}

/**
 * 获取客户资金明细
 */
export async function queryCustomBillInfo(uuid) {
  return http.get(crm.GET_CUSTOM_BILL_INFO, { billUuid: uuid });
}

/**
 * 客户资金关联
 */
export async function queryCustomRelationBill(params) {
  return http.post(crm.CUSTOM_RELATIONBILL, params);
}

/**
 * 删除客户资金
 */
export async function queryDeleteCustomBill(uuid) {
  return http.get(crm.DEL_CUSTOM, { uuid });
}



// WEBPACK FOOTER //
// ./src/api/crm/custom.js